import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { TokenStorage } from './token-storage';

/**
 * Intercepteur pour ajouter les en-têtes Authorization et CesarAccount.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenStorage: TokenStorage) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.tokenStorage.getToken();
    const user = JSON.parse(sessionStorage.getItem('user') || 'null');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    if (user && user.account) {
      req = req.clone({
        setHeaders: {
          CesarAccount: user.account,
        },
      });
    } else {
      console.warn('Aucun utilisateur trouvé dans le sessionStorage.');
    }

    return next.handle(req);
  }
}
